// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OrderDetailsGrid_gridContainer__1-TRi","gridOverlay":"OrderDetailsGrid_gridOverlay__dDhvB"};